import { AUTH, CLOSE_SOCKET, CREATE_SOCKET, FETCH_HISTORIC_NOTIFICATIONS, FETCH_MORE_HISTORIC_NOTIFICATIONS, LOGOUT, NOTIFICATION_FROM_SOCKET, REPOPULATE, SHOW_NOTIFICATIONS, UPDATE_PROFILE } from '../constants/actionTypes';

const dynamicUIReducer = (state = {showNotifications: false, showProfileMenu: false, showCreatePost: false, showUserPrompt: false}, action) => {

    switch (action.type) {

        case SHOW_NOTIFICATIONS:

            return {
                ...state,
                ...action.data
            }

        default:
            return state; 
    }
}

export default dynamicUIReducer; 